module.exports = __webpack_public_path__ + "img/Icon-navigation-More-vertical.2eb20ad0.svg";